import { combineEpics } from 'redux-observable';
import { forCollectionName } from './util';
import constants from '../constants';
import { actions } from '../reducers';

const setNewEvent$ = action$ => action$
  .ofAction(actions.collections.onePushed)
  .filter(forCollectionName('events'))
  .map(({ pushed }) => Object.keys(pushed)[0])
  .map(actions.schedule.setNewEvent);

const clearNewEvent$ = action$ => action$
  .ofAction(actions.schedule.setNewEvent)
  .delay(1)
  .map(actions.schedule.clearNewEvent);

const clearActiveEvent$ = action$ => action$
  .ofAction(actions.pages.goToPage)
  .map(actions.schedule.clearActiveEvent);


export default combineEpics(
  setNewEvent$,
  clearNewEvent$,
  clearActiveEvent$,
);



// WEBPACK FOOTER //
// ./src/epics/schedule.js